import * as Material from "@mui/material";
import React from "react";

export function Form_ToggleButton(props) {
    const { item, localFormState, setLocalFormState } = props;
    const {
        disabled = false,
        inputSize = "normal"
    } = item;
    const height = inputSize === "normal" ? 56 : 43;
    const lineHeight = inputSize === "normal" ? 24.5: 14.5;
    const paddingTop = inputSize === "normal" ? 6: 0;
    const clickHandler = (e) => {
        if (disabled) return;
        const currentValue = (localFormState[item.key] === null || localFormState[item.key] === undefined) ? false : localFormState[item.key];
        setLocalFormState({
            ...localFormState,
            [item.key]: !currentValue
        });
    }

    return (<>
        <Material.Button
            variant={"outlined"}
            fullWidth={true}
            style={{
                display: "block",
                height: `${height}px`,
                textAlign: "left",
                lineHeight: `${lineHeight}px`,
                paddingTop: `${paddingTop}px`
            }}
            disabled={disabled}
            disableElevation
            onClick={clickHandler}
        ><Material.Checkbox
            disabled={true}
            checked={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? false : localFormState[item.key]}
        />&nbsp;{item.label}</Material.Button>
    </>);
}

// {disabled?"disabled":"enabled"}